export default __webpack_public_path__ + "c1329c1b534efff68e53d6a5738d7195.png";